import { PlanCode } from '../../interfaces/IPlanCode';
import { Price } from '../../interfaces/IPrice';
import { SubscriptionPlans } from '../services/localization';
import { ANNUAL_PLAN_CODE, SEASONAL_PLAN_CODE } from './constants';

const getPriceByPlanCode = (prices: Price[], planCode: PlanCode) =>
  prices.find((p) => p.planCode === planCode);

const setPricesFromPlans = (plans: SubscriptionPlans): Price[] => {
  const seasonalPlan = plans[SEASONAL_PLAN_CODE];
  const annualPlan = plans[ANNUAL_PLAN_CODE];
  const planPrices = [
    {
      planCode: SEASONAL_PLAN_CODE,
      price: seasonalPlan?.boxPrice?.amount,
      annualPrice: seasonalPlan?.price?.amount,
      save: 0,
    },
    {
      planCode: ANNUAL_PLAN_CODE,
      price: annualPlan?.boxPrice?.amount,
      annualPrice: annualPlan?.price?.amount,
      save: 2000,
    },
  ];

  return planPrices;
};

export { getPriceByPlanCode, setPricesFromPlans };
